module.exports = __webpack_public_path__ + "img/mouth_male_thin.6df4b3ec.png";